import { Routes, Route } from "react-router-dom";
import React from "react";
import "./router.css";
import Dashboard from "../Pages/Dashboard/dashboard";
import BinTransferData from "../Pages/BinTransfer/BinTransferData";
import BinTrnasferForm from "../Pages/BinTransfer/BinTrnasferForm";
import BinTransferDetail from "../Pages/BinTransfer/BinTransferDetail";
import InstantPickingHead from "../Pages/Instant/instantPicking";
import VirtualBinDetail from "../Pages/VirtualBinDetail/VirtualBinDetail";
import DeliverySummary from "../Pages/Delivery/DeliverySummary";
import DeliveryDetail from "../Pages/Delivery/DeliveryDetail";
import InstantPickingDetail from "../Pages/Instant/instantPickingDetail";
import Picking from "../Pages/Picking/Picking";
import PickingDetailView from "../Pages/Picking/PickingDetail";
import WmsSalesInvoice from "../Pages/WMSSalesInvoice/WMSSalesInvoice";
import SalesQuotation from "../Pages/SalesQuotation/SalesQuotation";
import SalesOrder from "../Pages/SalesOrder/SalesOrder";
import SalesInvoice from "../Pages/SalesInvoice/SalesInvoice";
import SalesReturn from "../Pages/SalesReturn/SalesReturn";
import DelieveryNote from "../Pages/DelieveryNote/DelieveryNote";
import SalesInvoicev1 from "../Pages/SalesInvoice_001/SalesInvoice";
import DispatchHead from "../Pages/Dispatch/Dispatch";
import DispatchDetail from "../Pages/Dispatch/DispatchDetail";
import LoadingHead from "../Pages/Loading/Loading";
import LoadingDetail from "../Pages/Loading/LoadingDetail";
import EasyLoadingHead from "../Pages/EasyLoading/EasyLoading";
import EasyLoadingDetail from "../Pages/EasyLoading/EasyLoadingDetail";
import NotificationSummary from "../Pages/Notification/NotificationSummary";
import PickingHead from "../Pages/Notification/PickingHead";
import PickingPendingList from "../Pages/Notification/PickingPendingList";
import PickingDetail from "../Pages/Notification/PickingDetail";
import StockEnquiry from "../Pages/StockEnquiry/StockEnquiry";
import DCItemsPriority from "../Pages/DCItemsPriority/DCItemsPriority";
import GRNNormal from "../Pages/GRNNormal/GRNNormal";
import PurchaseOrder from "../Pages/PurchaseOrder/PurchaseOrder";
import SalesGroupUpdate from "../Pages/SalesGroupUpdate/SalesGroupUpdate";
import WmsOutboundGRV from "../Pages/OutboundGRV/OutboundGRV";
import GRV from "../Pages/GRV/GRV";
import WmsStockTransfer from "../Pages/StockTransfer/StockTransfer";
import WmsLoadingReceipt from "../Pages/LoadingReceipt/LoadingReceipt";
import Bin from "../Pages/bin/bin";
import Driver from "../Pages/Driver/Driver";
import WmsDashboard from "../Pages/WmsDashboard/WmsDashboard";
import Truck from "../Pages/Truck/Truck";
import WMSStockReport from "../Pages/WMSStockReport/WMSStockReport";
import WMSSalesReport from "../Pages/WMSSalesReport/WMSSalesReport";
import LoadingList from "./../Pages/LoadingList/LoadingList";
import DoStamping from "./../Pages/DoStamping/DoStamping";
import WmsStockAdjustment from "./../Pages/StockAdjustment/StockAdjustment";
import WmsPhysicalStockCount from "./../Pages/WmsPhysicalStockCount/WmsPhysicalStockCount";
import WmsPhysicalStockCountDetail from "./../Pages/WmsPhysicalStockCount/WmsPhysicalStockCountDetail";
import WmsPoPhysicalStockCount from "./../Pages/WmsPoPhysicalStockCount/WmsPoPhysicalStockCount";
import WmsPoPhysicalStockCountDetail from "./../Pages/WmsPoPhysicalStockCount/WmsPoPhysicalStockCountDetail";
import Cyclecount from "./../Pages/CycleCount/Cyclecount";
import CyclecountDetail from "./../Pages/CycleCount/CyclecountDetail";
import PhysicalStock from "./../Pages/PhysicalStock/PhysicalStock";
import PhysicalStockDetail from "./../Pages/PhysicalStock/PhysicalStockDetail";
import StockTransferReceipt from "./../Pages/StockTransferReceipt/StockTransferReceipt";
import StockTransferReceiptDetail from "./../Pages/StockTransferReceipt/StockTransferReceiptDetail";
import PutAway from "./../Pages/PutAway/PutAway";
import PutAwayDetail from "./../Pages/PutAway/PutAwayDetail";
import EasyPutAway from "./../Pages/EasyPutAway/EasyPutAway";
import EasyPutAwayDetail from "./../Pages/EasyPutAway/EasyPutAwayDetail";
import Login from "./../Pages/Login/login";
import { useSelector } from "react-redux";
import { GCPageNotFound } from "../Component/Common/ReuseableComponent/GCPageNotFound";
import PendingDoDetailReport from "./../Pages/PendingDoDetailReport/PendingDoDetailReport";
import TransDetailReport from "./../Pages/TransDetailReport/TransDetailReport";
import BinTransferReport from "./../Pages/BinTransferReport/BinTransferReport";
import DcCostCompareHistoryReport from "./../Pages/DcCostCompareHistoryReport/DcCostCompareHistoryReport";
import DcItemsStatusReport from "./../Pages/DcItemsStatusReport/DcItemsStatusReport";
import PoCostCompareReport from "./../Pages/PoCostCompareReport/PoCostCompareReport";
import BranchToDcTsrDetailReport from "./../Pages/BranchToDcTsrDetailReport/BranchToDcTsrDetailReport";
import DcRebateDetailReport from "./../Pages/DcRebateDetailReport/DcRebateDetailReport";
import OutletPlanningReport from "./../Pages/OutletPlanningReport/OutletPlanningReport";
import DCRequest from "./../Pages/DCRequest/DCRequest";
import FactTransaction from "../Pages/FactTransaction/FactTransaction";
import EasyBinTransferSummary from "../Pages/EasyBinTransfer/EasyBinTransferSummary";
import EasyItemTransfer from "../Pages/EasyBinTransfer/component/ItemTansfer/EasyItemTransfer";
import EasyItemTransferDetail from "../Pages/EasyBinTransfer/component/ItemTansfer/EasyItemTransferDetail";
import EasyCardIdTransfer from "../Pages/EasyBinTransfer/component/CardId/EasyCardIdTransfer";
import EasyCardIdTransferDetail from "../Pages/EasyBinTransfer/component/CardId/EasyCardIdTransferDetail";
import EasyBinTransfer from "../Pages/EasyBinTransfer/component/Bintransfer/EasyBinTransfer";
import EasyBinTransferDetail from "../Pages/EasyBinTransfer/component/Bintransfer/EasyBinTransferDetail";
import WmsDashboardDetail from "../Pages/WmsDashboard/WmsDashboardDetail";
import WmsPhysicalStockCounting from "../Pages/WmsPhysicalStockCount/WmsPhysicalStockCounting";
import WmsPhysicalStockVariance from "../Pages/WmsPhysicalStockVariance/WmsPhysicalStockVariance";
import DeliveryItemDetail from "../Pages/Delivery/DeliveryItemDetail";
import InboundProcessFlowReport from "../Pages/InboundProcessFlowReport/InboundProcessFlowReport";
import PutawayDiscrepancyReport from "../Pages/PutawayDiscrepancyReport/PutawayDiscrepancyReport";
import EmptyBinQurey from "../Pages/EmptyBinQurey/EmptyBinQurey";
import DispatchDetails from "../Pages/DispatchDetails/DispatchDetails";
import Test from "../Pages/QRCodeScanner/QRCodeScanner";
import TripDetailSummary from "../Pages/EasyLoading/TripDetailSummary";
import SegregationSummary from "../Pages/Segregation/segregationSummary";
import SegregationItemScan from "../Pages/Segregation/segregationItemScan";
import SegregrationDetail from "../Pages/Segregation/segregrationDetail";
import StockTransferNormal from "../Pages/StockTransferNormal/StockTransfer";
import StockAdjustmentNormal from "../Pages/StockAdjustmentNormal/StockAdjustment";
import PriceEnquiry from "../Pages/PriceEnquiry/PriceEnquiry";
import WHPickingSummary from "../Pages/WHPicking/Summary";
import WHPickingDetail from "../Pages/WHPicking/Detail";
import DropIdEnquiry from "../Pages/DropIdEnquiry/DropIdEnquiry";
import BarcodeScanning from "../Pages/BarcodeScanning/BarcodeScanning";
import OrderTakingFromCar from "../Pages/orderTakingFromCar/orderTakingFromCar";
import Cart from "../Pages/cart/cart";
import OrderPicking from "../Pages/OrderPicking/OrderPicking";
import OrderDelivery from "../Pages/OrderDelivery/OrderDelivery";
import OrderDetailPage from "../Pages/OrderPicking/OrderDetailPage";
import OrderDeliveryDetail from "../Pages/OrderDelivery/OrderDeliveryDetail";
import Enquiry from "../Pages/Enquiry/enquiry";
import PdfPreview from "../Pages/PdfPreview/PdfPreview";
import OrderCancel from "../Pages/OrderCancel/OrderCancel";
import VendorCreditNote from "../Pages/VendorCreditNote/VendorCreditNote";
import BatchOut from "../Pages/BatchOut/BatchOut";
import BatchOutDetail from "../Pages/BatchOut/BatchOutDetail";
import ItemCreationRequest from "../Pages/ItemCreationRequest/ItemCreationRequest";
import ItemApproveSummary from "../Pages/ItemApprove/ItemApproveSummary";
import ItemApproveDetail from "../Pages/ItemApprove/ItemApproveDetail";
import ItemRequestSummary from "../Pages/ItemCreationRequest/ItemRequestSummary";
import WmsInboundGRNV1 from "../Pages/InboundGRN/InboundGRNV1";
import CycleCountAdjustment from "../Pages/CycleCountAdjustment/CycleCountAdjustment";
import CycleCountCounting from "../Pages/CycleCountCounting/CycleCountCounting";
import CycleCountSetting from "../Pages/CycleCountSetting/CycleCountSetting";
import CycleCountVariance from "../Pages/CycleCountVariance/CycleCountVariance";
import HRMonthlyReview from "../Pages/HRMonthlyReview/HRMonthlyReview";
import HRMonthlyReviewApprove from "../Pages/HRMonthlyReviewApprove/HRMonthlyReviewApprove";
import HRReviewReport from "../Pages/HRReviewReport/HRReviewReport";
import WmsInboundVendor from "../Pages/WmsInboundVendor/WmsInboundVendor";
import HRSalaryAppraisal from "../Pages/HRSalaryAppraisal/HRSalaryAppraisal";
import WmsInboundReturn from "../Pages/WmsInboundReturn/WmsInboundReturn";
import WmsInboundOutlet from "../Pages/WmsInboundOutlet/WmsInboundOutlet";
import MobileCoupen from "../Pages/MobileCoupen/MobileCoupen";
import BinWiseCBMRreport from "../Pages/BinWiseCBMRreport/BinWiseCBMRreport";
import PickersPerformance from "../Pages/PickersPerformance/PickersPerformance";
import BoxPalletReceipt from "../Pages/BoxPalletReceipt/BoxPalletReceipt";
import BoxPalletReport from "../Pages/BoxPalletReport/BoxPalletReport";
import LoadingPalletId from "../Pages/Loading/LoadingPalletId";
import PromoSummary from "../Pages/Promotion/Summary";
import StockTransferRequest from "../Pages/StockTransferRequest/StockTransferRequest";
import StockSetupApprove from "../Pages/StockSetupApprove/StockSetupApprove";
import WmsPoPhysicalStockCountSetup from "../Pages/WmsPoPhysicalStockCountSetup/WmsPoPhysicalStockCountSetup";
import WmsPoGenerateVaraiance from "../Pages/WmsPoGenerateVaraiance/WmsPoGenerateVaraiance";
import WmsTrackerReport from "../Pages/WmsTrackerReport/WmsTrackerReport";
import StockSetupChangeRequest from "../Pages/StockSetupChangeRequest/StockSetupChangeRequest";
import StockSetupChangeRequestDetail from "../Pages/StockSetupChangeRequest/StockSetupChangeRequestDetail";
import CouponSummary from "../Pages/DiscountCoupon/CouponSummary";
import StockSetupChangeApprove from "../Pages/StockSetupChangeApprove/StockSetupChangeApprove";
import RestaurantOrderSummary from "../Pages/RestaurantOrderPicking/Components/restaurant-order-summary";
import VendorDiscontinueChangeRequest from "../Pages/VendorDiscontinueChangeRequest/VendorDiscontinueChangeRequest";
import VendorDiscontinueChangeRequestDetail from "../Pages/VendorDiscontinueChangeRequest/VendorDiscontinueChangeRequestDetail";
import WmsOutboundGRVV1 from "../Pages/OutboundGRV/OutboundGRVV1";
import BrandSearchPicker from "../Pages/WMSStockReport/BrandSearch";
import VendorDiscontinueChangeApprove from "../Pages/VendorDiscontinueChangeApprove/VendorDiscontinueChangeApprove";
import WmsSalesInvoiceV1 from "../Pages/WMSSalesInvoice/WMSSalesInvoiceV1";
import ItemListingRequest from "../Pages/ItemListingRequest/ItemListingRequest";
import ItemListingRequestDetail from "../Pages/ItemListingRequest/ItemListingRequestDetail";
import ItemListApprove from "../Pages/ItemListApprove/ItemListApprove";
import ItemMoqRequest from "../Pages/ItemMoqRequest/ItemMoqRequest";
import ItemMoqRequestDetail from "../Pages/ItemMoqRequest/ItemMoqRequestDetail";
import PutAwayGeneration from "../Pages/PutAwayGeneration/PutAwayGeneration";
import Layout from "../Pages/Layout/layout";
import MOQApprove from "../Pages/ItemMOQApprove/MOQApprove";
import WmsPutAway from "../Pages/WmsPutAway/WmsPutAway";
import WmsPutAwayDetail from "../Pages/WmsPutAway/WmsPutAwayDetail";
import ProtectedRoute from "../Utility/ProtectedRoute";
import GeneralLedger from "../Pages/FinanceGeneralLedger/GeneralLedger";
import FinanceReceivableReport from "../Pages/FinanceReceivableReport/FinanceReceivableReport";
import FinanceTrialBalanceReport from "../Pages/FinanceTrialBalanceReport/FinanceTrialBalanceReport";
import FinancePayableReport from "../Pages/FinancePayableReport/FinancePayableReport";
import GenerateApiKey from "../Pages/APIKeyGenration/ApiKeyGenration";
import ZatcaTransactionSummary from "../Pages/Zatca/ZatcaTransactionSummary";
import ZatcaTransactionDetail from "../Pages/Zatca/ZatcaTransactionDetail";
import RSPChangeDetail from "../Pages/RSPChangeRequest/RSPChangeDetail";
import RSPChangeSummary from "../Pages/RSPChangeRequest/RSPChangeSummary";
import RSPChangeApproveSummary from "../Pages/RSPChangeApprove/RSPChangeApproveSummary";
import ImportPurchaseSummary from "../Pages/ImportPurchasePlanning/ImportPurchaseSummary";
import { ImportPurchase } from "../Pages/Purchase/ImportPurchaseSummary";
import PurchaseCloseSummary from "../Pages/ImportPurchaseClose/PurchaseCloseSummary";
import DirectPriceChange from "../Pages/DirectPriceChange/DirectPriceChange";
import VansalesCustomerSummary from "../Pages/VansalesCustomer/VansalesCustomerSummary";
import FreshPurchasePosting from "../Pages/FreshPurchasePosting/FreshPurchasePosting";
import FreshDcMargin from "../Pages/PoFreshDcMargin/FreshDcMargin";
import RSPRejectReport from "../Pages/RSPChangeApprove/RSPRejectReport";
import PromotionAutomationSummary from "../Pages/PromotionAutomation/Components/Summary";
import TripPlanningSummary from "../Pages/TripPlanning/TripPlanningSummary";
import StockSetupTemplate from "../Pages/StockSetupTemplate/StockSetupTemplate";
import BranchClassification from "../Pages/BranchClassification/BranchClassification";
import InsuranceSetup from "../Pages/InsuranceSetup/InsuranceSetup";
import ItemMSP from "../Pages/ItemMSP/ItemMSP";
import ItemCreationSummary from "../Pages/ItemCreation/ItemCreationSummary";
import ItemMSPExcel from "../Pages/ItemMSPExcel/ItemMSPExcel";
import StockSetupDaysTemplate from "../Pages/StockSetupDaysTemplate/StockSetupDaysTemplate";
import PickingList from "../Pages/PickingList/PickingList";




function getRouteComponent(webRoute) {
  switch (webRoute) {
    case "/TripDetail":
      return (
        <>
          <Route path="/TripDetail" element={<TripDetailSummary />} />
        </>
      );
    case "/WmsInboundGRN":
      return (
        <>
          {/* <Route path="/WmsInboundGRN" element={<WmsInboundGRN />} /> */}
          <Route path="/WmsInboundGRN" element={<WmsInboundGRNV1 />} />
        </>
      );
    case "/grn":
      return (
        <>
          <Route path="/grn" element={<GRNNormal />} />
        </>
      );
    case "/PurchaseOrder":
      return (
        <>
          <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
        </>
      );
    case "/InstantPicking":
      return (
        <>
          <Route path="/InstantPicking" element={<InstantPickingHead />} />
          <Route
            path="/InstantPickingDetail"
            element={<InstantPickingDetail />}
          />
        </>
      );
    case "/VirtualBinDetail":
      return (
        <>
          <Route path="/VirtualBinDetail" element={<VirtualBinDetail />} />
        </>
      );
    case "/deliverySummary":
      return (
        <>
          <Route path="/deliverySummary" element={<DeliverySummary />} />
          <Route path="/deliveryDetail" element={<DeliveryDetail />} />
          <Route path="/deliveryItemDetail" element={<DeliveryItemDetail />} />
        </>
      );
    case "/Picking":
      return (
        <>
          <Route path="/Picking" element={<Picking />} />
          <Route path="/PickingDetailView" element={<PickingDetailView />} />
        
        </>

        
      );
    case "/BinTransferData":
      return (
        <>
          <Route path="/BinTransferData" element={<BinTransferData />} />
          <Route path="/BinTrnasferForm" element={<BinTrnasferForm />} />
          <Route path="/BinTransfer/:id" element={<BinTransferDetail />} />
        </>
      );
    case "/WmsSalesInvoice":
      return (
        <>
          <Route path="/WmsSalesInvoice" element={<WmsSalesInvoiceV1 />} />
        </>
      );
    case "/SalesInvoice":
      return (
        <>
          <Route path="/SalesInvoice" element={<SalesInvoice />} />
        </>
      );
    case "/SalesReturn":
      return (
        <>
          <Route path="/SalesReturn" element={<SalesReturn />} />
        </>
      );
    case "/DeliveryNote":
      return (
        <>
          <Route path="/DeliveryNote" element={<DelieveryNote />} />
        </>
      );
    case "/WmsOutboundGRV":
      return (
        <>
          <Route path="/WmsOutboundGRV" element={<WmsOutboundGRVV1 />} />
        </>
      );
    case "/grv":
      return (
        <>
          <Route path="/grv" element={<GRV />} />
        </>
      );
    case "/WmsStockTransfer":
      return (
        <>
          <Route path="/WmsStockTransfer" element={<WmsStockTransfer />} />
        </>
      );
    case "/stocktransfer":
      return (
        <>
          <Route path="/stocktransfer" element={<StockTransferNormal />} />
        </>
      );
    case "/StockTransferRequest":
      return (
        <>
          <Route
            path="/StockTransferRequest"
            element={<StockTransferRequest />}
          />
        </>
      );
    case "/StockAdjustment":
      return (
        <>
          <Route path="/StockAdjustment" element={<StockAdjustmentNormal />} />
        </>
      );
    case "/dropIdEnquiry":
      return (
        <>
          <Route path="/dropIdEnquiry" element={<DropIdEnquiry />} />
        </>
      );
    case "/WmsLoadingReceipt":
      return (
        <>
          <Route path="/WmsLoadingReceipt" element={<WmsLoadingReceipt />} />
        </>
      );
    case "/binMaster":
      return (
        <>
          <Route path="/binMaster" element={<Bin />} />
        </>
      );
    case "/driver":
      return (
        <>
          <Route path="/driver" element={<Driver />} />
        </>
      );
    case "/wmsDashoard":
      return (
        <>
          <Route path="/wmsDashoard" element={<WmsDashboard />} />
          <Route path="/WmsDashboardDetail" element={<WmsDashboardDetail />} />
        </>
      );
    case "/truck":
      return (
        <>
          <Route path="/truck" element={<Truck />} />
        </>
      );
    case "/LoadingList":
      return (
        <>
          <Route path="/LoadingList" element={<LoadingList />} />
        </>
      );
    case "/WMSDispatch":
      return (
        <>
          <Route path="/WMSDispatch" element={<DispatchHead />} />
          <Route path="/DispatchDetail" element={<DispatchDetail />} />
        </>
      );
    case "/ItemRSPRequest":
      return (
        <>
          <Route path="/ItemRSPRequest" element={<RSPChangeSummary />} />
          <Route path="/RSPChangeRequestDetail" element={<RSPChangeDetail />} />
        </>
      );
    case "/ItemRSPApprove?type=":
      return (
        <>
          <Route path="/ItemRSPApprove" element={<RSPChangeApproveSummary />} />
        </>
      );
    case "/ItemRSPApproveCM?type=CM":
      return (
        <>
          <Route
            path="/ItemRSPApproveCM"
            element={<RSPChangeApproveSummary />}
          />
        </>
      );
    case "/ItemRSPApprovePM?type=PM":
      return (
        <>
          <Route
            path="/ItemRSPApprovePM"
            element={<RSPChangeApproveSummary />}
          />
        </>
      );

    case "/ItemRejectReport":
      return (
        <>
          <Route path="/ItemRejectReport" element={<RSPRejectReport />} />
        </>
      );
    case "/StockSetupChangeRequest":
      return (
        <>
          <Route
            path="/StockSetupChangeRequest"
            element={<StockSetupChangeRequest />}
          />
          <Route
            path="/StockSetupChangeRequestDetail"
            element={<StockSetupChangeRequestDetail />}
          />
        </>
      );
    case "/StockSetupChangeApprove?type=":
      return (
        <>
          <Route
            path="/StockSetupChangeApprove"
            element={<StockSetupChangeApprove />}
          />
        </>
      );

    case "/StockSetupChangeApproveCM?type=CM":
      return (
        <>
          <Route
            path="/StockSetupChangeApproveCM"
            element={<StockSetupChangeApprove />}
          />
        </>
      );
    case "/StockSetupChangeApprovePM?type=PM":
      return (
        <>
          <Route
            path="/StockSetupChangeApprovePM"
            element={<StockSetupChangeApprove />}
          />
        </>
      );
    case "/VendorDiscontinueChangeApprove?type=":
      return (
        <>
          <Route
            path="/VendorDiscontinueChangeApprove"
            element={<VendorDiscontinueChangeApprove />}
          />
        </>
      );
    case "/VendorDiscontinueChangeApproveCM?type=CM":
      return (
        <>
          <Route
            path="/VendorDiscontinueChangeApproveCM"
            element={<VendorDiscontinueChangeApprove />}
          />
        </>
      );
    case "/VendorDiscontinueChangeApprovePM?type=PM":
      return (
        <>
          <Route
            path="/VendorDiscontinueChangeApprovePM"
            element={<VendorDiscontinueChangeApprove />}
          />
        </>
      );

    case "/VendorDiscontinueChangeRequest":
      return (
        <>
          <Route
            path="/VendorDiscontinueChangeRequest"
            element={<VendorDiscontinueChangeRequest />}
          />
          <Route
            path="/VendorDiscontinueChangeRequestDetail"
            element={<VendorDiscontinueChangeRequestDetail />}
          />
        </>
      );
    case "/ItemListingApprove?type=":
      return (
        <>
          <Route path="/ItemListingApprove" element={<ItemListApprove />} />
        </>
      );
    case "/ItemListingApproveCM?type=CM":
      return (
        <>
          <Route path="/ItemListingApproveCM" element={<ItemListApprove />} />
        </>
      );
    case "/ItemListingApprovePM?type=PM":
      return (
        <>
          <Route path="/ItemListingApprovePM" element={<ItemListApprove />} />
        </>
      );

    case "/ItemListingRequest":
      return (
        <>
          <Route path="/ItemListingRequest" element={<ItemListingRequest />} />
          <Route
            path="/ItemListingDetail"
            element={<ItemListingRequestDetail />}
          />
        </>
      );
    case "/ItemMoqRequest":
      return (
        <>
          <Route path="/ItemMoqRequest" element={<ItemMoqRequest />} />
          <Route path="/ItemMoqDetail" element={<ItemMoqRequestDetail />} />
        </>
      );
    case "/ItemMoqApprove?type=":
      return (
        <>
          <Route path="/ItemMoqApprove" element={<MOQApprove />} />
        </>
      );
    case "/ItemMoqApproveCM?type=CM":
      return (
        <>
          <Route path="/ItemMoqApproveCM" element={<MOQApprove />} />
        </>
      );
    case "/ItemMoqApprovePM?type=PM":
      return (
        <>
          <Route path="/ItemMoqApprovePM" element={<MOQApprove />} />
        </>
      );
    case "/Loading":
      return (
        <>
          <Route path="/Loading" element={<LoadingHead />} />
          <Route path="/LoadingDetail" element={<LoadingDetail />} />
          <Route path="/LoadingPalletId" element={<LoadingPalletId />} />
        </>
      );
    case "/EasyLoading":
      return (
        <>
          <Route path="/EasyLoading" element={<EasyLoadingHead />} />
          <Route path="/EasyLoadingDetail" element={<EasyLoadingDetail />} />
        </>
      );
    case "/Notification":
      return (
        <>
          <Route path="/Notification" element={<NotificationSummary />} />
          <Route path="/PickingHead" element={<PickingHead />} />
          <Route path="/PickingPendingList" element={<PickingPendingList />} />
          <Route path="/PickingDetail" element={<PickingDetail />} />
        </>
      );
    case "/StockEnquiry":
      return (
        <>
          <Route path="/StockEnquiry" element={<StockEnquiry />} />
        </>
      );
    case "/priceenquiry":
      return (
        <>
          <Route path="/priceenquiry" element={<PriceEnquiry />} />
        </>
      );
    case "/WHPicking":
      return (
        <>
          <Route path="/WHPicking" element={<WHPickingSummary />} />
          <Route path="/WHPickingDetail" element={<WHPickingDetail />} />
        </>
      );
    case "/SalesGroupUpdate":
      return (
        <>
          <Route path="/SalesGroupUpdate" element={<SalesGroupUpdate />} />
        </>
      );
    case "/DoStamping":
      return (
        <>
          <Route path="/DoStamping" element={<DoStamping />} />
        </>
      );
    case "/WmsStockAdjustment":
      return (
        <>
          <Route path="/WmsStockAdjustment" element={<WmsStockAdjustment />} />
        </>
      );
    case "/WmsPhysicalStock":
      return (
        <>
          <Route path="/WmsPhysicalStock" element={<WmsPhysicalStockCount />} />
        </>
      );
    case "/WmsPhysicalStockCount":
      return (
        <>
          <Route
            path="/WmsPhysicalStockCount"
            element={<WmsPhysicalStockCounting />}
          />
          <Route
            path="/WmsPhysicalStockDetail"
            element={<WmsPhysicalStockCountDetail />}
          />
        </>
      );
    case "/WmsPoPhysicalStock":
      return (
        <>
          <Route
            path="/WmsPoPhysicalStock"
            element={<WmsPoPhysicalStockCount />}
          />
          <Route
            path="/WmsPoPhysicalStockDetail"
            element={<WmsPoPhysicalStockCountDetail />}
          />
        </>
      );
    case "/WmsPoPhysicalSetting":
      return (
        <>
          <Route
            path="/WmsPoPhysicalSetting"
            element={<WmsPoPhysicalStockCountSetup />}
          />
        </>
      );
    case "/cyclecount":
      return (
        <>
          <Route path="/cyclecount" element={<Cyclecount />} />
          <Route path="/cyclecountDetail" element={<CyclecountDetail />} />
        </>
      );
    case "/PhysicalStock":
      return (
        <>
          <Route path="/PhysicalStock" element={<PhysicalStock />} />
          <Route
            path="/PhysicalStockDetail"
            element={<PhysicalStockDetail />}
          />
        </>
      );
    case "/BatchOut":
      return (
        <>
          <Route path="/BatchOut" element={<BatchOut />} />
          <Route path="/BatchOutDetail" element={<BatchOutDetail />} />
        </>
      );
    case "/StockTransferReceipt":
      return (
        <>
          <Route
            path="/StockTransferReceipt"
            element={<StockTransferReceipt />}
          />
          <Route
            path="/StockTransferReceiptDetail"
            element={<StockTransferReceiptDetail />}
          />
        </>
      );
    case "/PutAway":
      return (
        <>
          <Route path="/PutAway" element={<PutAway />} />
          <Route path="/PutAwayDetail" element={<PutAwayDetail />} />
        </>
      );
    case "/EasyPutAway":
      return (
        <>
          <Route path="/EasyPutAway" element={<EasyPutAway />} />
          <Route path="/EasyPutAwayDetail" element={<EasyPutAwayDetail />} />
        </>
      );
    case "/WMSStockReport":
      return (
        <>
          <Route path="/WMSStockReport" element={<WMSStockReport />} />
        </>
      );
    case "/WMSSalesReport":
      return (
        <>
          <Route path="/WMSSalesReport" element={<WMSSalesReport />} />
        </>
      );
    case "/DCItemsPriority":
      return (
        <>
          <Route path="/DCItemsPriority" element={<DCItemsPriority />} />
        </>
      );
    case "/PendingDoDetailReport":
      return (
        <>
          <Route
            path="/PendingDoDetailReport"
            element={<PendingDoDetailReport />}
          />
        </>
      );
    case "/TransDetailReport":
      return (
        <>
          <Route path="/TransDetailReport" element={<TransDetailReport />} />
        </>
      );
    case "/BinTransferReport":
      return (
        <>
          <Route path="/BinTransferReport" element={<BinTransferReport />} />
        </>
      );
    case "/DcCostCompareHistoryReport":
      return (
        <>
          <Route
            path="/DcCostCompareHistoryReport"
            element={<DcCostCompareHistoryReport />}
          />
        </>
      );
    case "/DcItemsStatusReport":
      return (
        <>
          <Route
            path="/DcItemsStatusReport"
            element={<DcItemsStatusReport />}
          />
        </>
      );
    case "/PoCostCompareReport":
      return (
        <>
          <Route
            path="/PoCostCompareReport"
            element={<PoCostCompareReport />}
          />
        </>
      );
    case "/BranchToDcTsrDetailReport":
      return (
        <>
          <Route
            path="/BranchToDcTsrDetailReport"
            element={<BranchToDcTsrDetailReport />}
          />
        </>
      );
    case "/DcRebateDetail":
      return (
        <>
          <Route path="/DcRebateDetail" element={<DcRebateDetailReport />} />
        </>
      );
    case "/OutletPlanningReport":
      return (
        <>
          <Route
            path="/OutletPlanningReport"
            element={<OutletPlanningReport />}
          />
        </>
      );
    case "/DCRequest":
      return (
        <>
          <Route path="/DCRequest" element={<DCRequest />} />
        </>
      );

    case "/SalesQuotation":
      return (
        <>
          <Route path="/SalesQuotation" element={<SalesQuotation />} />
        </>
      );

    case "/SalesOrder":
      return (
        <>
          <Route path="/SalesOrder" element={<SalesOrder />} />
        </>
      );
    case "/FactTransSync":
      return (
        <>
          <Route path="/FactTransSync" element={<FactTransaction />} />
        </>
      );
    case "/WmsPhysicalStockVariance":
      return (
        <>
          <Route
            path="/WmsPhysicalStockVariance"
            element={<WmsPhysicalStockVariance />}
          />
        </>
      );
    case "/EasyBinTransferSummary":
      return (
        <>
          <Route
            path="/EasyBinTransferSummary"
            element={<EasyBinTransferSummary />}
          />
          <Route path="/EasyItemTransfer" element={<EasyItemTransfer />} />
          <Route
            path="/EasyItemTransferDetail"
            element={<EasyItemTransferDetail />}
          />
          <Route path="/EasyCardIdTransfer" element={<EasyCardIdTransfer />} />
          <Route
            path="/EasyCardIdTransferDetail"
            element={<EasyCardIdTransferDetail />}
          />
          <Route path="/EasyBinTransfer" element={<EasyBinTransfer />} />
          <Route
            path="/EasyBinTransferDetail"
            element={<EasyBinTransferDetail />}
          />
        </>
      );
    case "/InboundProcessFlowReport":
      return (
        <>
          <Route
            path="/InboundProcessFlowReport"
            element={<InboundProcessFlowReport />}
          />
        </>
      );
    case "/PutawayDiscrepancyReport":
      return (
        <>
          <Route
            path="/PutawayDiscrepancyReport"
            element={<PutawayDiscrepancyReport />}
          />
        </>
      );
    case "/EmptyBinQurey":
      return (
        <>
          <Route path="/EmptyBinQurey" element={<EmptyBinQurey />} />
        </>
      );
    case "/DispatchDetails":
      return (
        <>
          <Route path="/DispatchDetails" element={<DispatchDetails />} />
        </>
      );
    case "/segregationSummary":
      return (
        <>
          <Route path="/segregationSummary" element={<SegregationSummary />} />
          <Route
            path="/segregationItemScan"
            element={<SegregationItemScan />}
          />
          <Route path="/segregrationDetail" element={<SegregrationDetail />} />
        </>
      );
    case "/BarcodeScanning":
      return (
        <>
          <Route path="/BarcodeScanning" element={<BarcodeScanning />} />
        </>
      );
    case "mposordertaking":
      return (
        <>
          <Route path="/mposordertaking" element={<OrderTakingFromCar />} />
          <Route path="/cart" element={<Cart />} />
        </>
      );
    case "/mposorderenquiry":
      return (
        <>
          <Route path="/mposorderenquiry" element={<Enquiry />} />
        </>
      );
    case "mposorderpicking":
      return (
        <>
          <Route path="/mposorderpicking" element={<OrderPicking />} />
          <Route
            path="/mposrderpickingDetail/:orderId"
            element={<OrderDetailPage />}
          />
        </>
      );
    case "mposorderdelivery":
      return (
        <>
          <Route path="/mposorderdelivery" element={<OrderDelivery />} />
          <Route
            path="/orderDeliveryDetail/:deliveryId"
            element={<OrderDeliveryDetail />}
          />
        </>
      );
    case "mposorderpending":
      return (
        <>
          <Route path="/mposorderpending" element={<OrderCancel />} />
        </>
      );
    case "/TableOrder":
      return (
        <>
          <Route path="/TableOrder" element={<RestaurantOrderSummary />} />
        </>
      );
    case "/ItemRequestSummary":
      return (
        <>
          <Route path="/ItemRequestSummary" element={<ItemRequestSummary />} />
          <Route
            path="/ItemCreationRequest"
            element={<ItemCreationRequest />}
          />
        </>
      );
    case "/ItemApproveSummary":
      return (
        <>
          <Route path="/ItemApproveSummary" element={<ItemApproveSummary />} />
          <Route path="/ItemApproveDetail" element={<ItemApproveDetail />} />
        </>
      );
    case "preview-pdf":
      return (
        <>
          <Route path="/preview-pdf" element={<PdfPreview />} />
        </>
      );
    case "/CycleCountAdjustment":
      return (
        <>
          <Route
            path="/CycleCountAdjustment"
            element={<CycleCountAdjustment />}
          />
        </>
      );
    case "/CycleCountCounting":
      return (
        <>
          <Route path="/CycleCountCounting" element={<CycleCountCounting />} />
        </>
      );
    case "/CycleCountSetting":
      return (
        <>
          <Route path="/CycleCountSetting" element={<CycleCountSetting />} />
        </>
      );
    case "/CycleCountVariance":
      return (
        <>
          <Route path="/CycleCountVariance" element={<CycleCountVariance />} />
        </>
      );
    case "/HRMonthlyReview":
      return (
        <>
          <Route path="/HRMonthlyReview" element={<HRMonthlyReview />} />
        </>
      );
    case "/HRMonthlyReviewApprove":
      return (
        <>
          <Route
            path="/HRMonthlyReviewApprove"
            element={<HRMonthlyReviewApprove />}
          />
        </>
      );
    case "/HRReviewReport":
      return (
        <>
          <Route path="/HRReviewReport" element={<HRReviewReport />} />
        </>
      );
    case "/WmsInboundVendor":
      return (
        <>
          <Route path="/WmsInboundVendor" element={<WmsInboundVendor />} />
        </>
      );
    case "/WmsInboundReturn":
      return (
        <>
          <Route path="/WmsInboundReturn" element={<WmsInboundReturn />} />
        </>
      );
    case "/WmsInboundOutlet":
      return (
        <>
          <Route path="/WmsInboundOutlet" element={<WmsInboundOutlet />} />
        </>
      );

    case "/HRSalaryAppraisal":
      return (
        <>
          <Route path="/HRSalaryAppraisal" element={<HRSalaryAppraisal />} />
        </>
      );
    case "/MobileCoupen":
      return (
        <>
          <Route path="/MobileCoupen" element={<MobileCoupen />} />
        </>
      );
    case "/BinWiseCBMRreport":
      return (
        <>
          <Route path="/BinWiseCBMRreport" element={<BinWiseCBMRreport />} />
        </>
      );
    case "/PickersPerformance":
      return (
        <>
          <Route path="/PickersPerformance" element={<PickersPerformance />} />
        </>
      );
    case "/boxpalletreceipt":
      return (
        <>
          <Route path="/boxpalletreceipt" element={<BoxPalletReceipt />} />
        </>
      );
    case "/boxpalletissue":
      return (
        <>
          <Route path="/boxpalletissue" element={<BoxPalletReceipt />} />
        </>
      );
    case "/boxpalletreport":
      return (
        <>
          <Route path="/boxpalletreport" element={<BoxPalletReport />} />
        </>
      );
    case "/LoadingPalletId":
      return (
        <>
          <Route path="/LoadingPalletId" element={<LoadingPalletId />} />
        </>
      );
    case "/AppPromotion":
      return (
        <>
          <Route path="/AppPromotion" element={<PromoSummary />} />
        </>
      );
    case "/StockSetupApprove":
      return (
        <>
          <Route path="/StockSetupApprove" element={<StockSetupApprove />} />
        </>
      );

    case "/WmsTrackerReport":
      return (
        <>
          <Route path="/WmsTrackerReport" element={<WmsTrackerReport />} />
        </>
      );
    case "/DiscountCoupon":
      return (
        <>
          <Route path="/DiscountCoupon" element={<CouponSummary />} />
        </>
      );
    case "/WmsPoPhysicalStockVariance":
      return (
        <>
          <Route
            path="/WmsPoPhysicalStockVariance"
            element={<WmsPoGenerateVaraiance />}
          />
        </>
      );
    case "/wmsPutawayGeneration":
      return (
        <>
          <Route path="/wmsPutawayGeneration" element={<PutAwayGeneration />} />
        </>
      );
    case "/wmsPutaway":
      return (
        <>
          <Route path="/wmsPutaway" element={<WmsPutAway />} />
          <Route path="/WmsPutAwayDetail" element={<WmsPutAwayDetail />} />
        </>
      );

    case "/FinanceGeneralLedger":
      return (
        <>
          <Route path="/FinanceGeneralLedger" element={<GeneralLedger />} />;
        </>
      );
    case "/FinanceReceivableReport":
      return (
        <>
          <Route
            path="/FinanceReceivableReport"
            element={<FinanceReceivableReport />}
          />
          ;
        </>
      );
    case "/FinanceTrialBalanceReport":
      return (
        <>
          <Route
            path="/FinanceTrialBalanceReport"
            element={<FinanceTrialBalanceReport />}
          />
          ;
        </>
      );
    case "/FinancePayableReport":
      return (
        <>
          <Route
            path="/FinancePayableReport"
            element={<FinancePayableReport />}
          />
          ;
        </>
      );
    case "/ZatcaTransactionSummary":
      return (
        <>
          <Route
            path="/ZatcaTransactionSummary"
            element={<ZatcaTransactionSummary />}
          />
          <Route
            path="/ZatcaTransactionDetail"
            element={<ZatcaTransactionDetail />}
          />
        </>
      );
    case "/ImportPurchasePlanning":
      return (
        <>
          <Route
            path="/ImportPurchasePlanning"
            element={<ImportPurchaseSummary />}
          />
        </>
      );
    case "/ImportPurchaseSummary":
      return (
        <>
          <Route path="/ImportPurchaseSummary" element={<ImportPurchase />} />
        </>
      );
    case "/ImportPurchaseClose":
      return (
        <>
          <Route
            path="/ImportPurchaseClose"
            element={<PurchaseCloseSummary />}
          />
        </>
      );
    case "/ImportPurchaseTrip":
      return (
        <>
          <Route path="/ImportPurchaseTrip" element={<TripPlanningSummary />} />
        </>
      );
       case "/ImportItemCreation":
      return (
        <>
          <Route path="/ImportItemCreation" element={<ItemCreationSummary />} />
        </>
      );
    case "/DirectPriceChange":
      return (
        <>
          <Route path="/DirectPriceChange" element={<DirectPriceChange />} />
        </>
      );
    case "/VansalesCustomer":
      return (
        <>
          <Route
            path="/VansalesCustomer"
            element={<VansalesCustomerSummary />}
          />
        </>
      );
    case "/FreshPurchasePosting":
      return (
        <>
          <Route
            path="/FreshPurchasePosting"
            element={<FreshPurchasePosting />}
          />
        </>
      );
    case "/FreshDcMargin":
      return (
        <>
          <Route path="/FreshDcMargin" element={<FreshDcMargin />} />
        </>
      );
    case "/PromotionCreation?typ=Initialize":
      return (
        <>
          <Route
            path="/PromotionCreation"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionCategory?typ=Category":
      return (
        <>
          <Route
            path="/PromotionCategory"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionItems?typ=Items":
      return (
        <>
          <Route
            path="/PromotionItems"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionItemsVerify?typ=ItemsVerify":
      return (
        <>
          <Route
            path="/PromotionItemsVerify"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionDesign?typ=Design":
      return (
        <>
          <Route
            path="/PromotionDesign"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionProofReading?typ=ProofReading":
      return (
        <>
          <Route
            path="/PromotionProofReading"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionPrint?typ=Print":
      return (
        <>
          <Route
            path="/PromotionPrint"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionReceived?typ=Received":
      return (
        <>
          <Route
            path="/PromotionReceived"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionDistribution?typ=Distribution":
      return (
        <>
          <Route
            path="/PromotionDistribution"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionAnalysis?typ=Analysis":
      return (
        <>
          <Route
            path="/PromotionAnalysis"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/PromotionCreditNote?typ=CreditNote":
      return (
        <>
          <Route
            path="/PromotionCreditNote"
            element={<PromotionAutomationSummary />}
          />
        </>
      );
    case "/StockSetupTemplate":
      return (
        <>
          <Route path="/StockSetupTemplate" element={<StockSetupTemplate />} />
        </>
      );
    case "/BranchClassification":
      return (
        <>
          <Route
            path="/BranchClassification"
            element={<BranchClassification />}
          />
        </>
      );
    case "/InsuranceSetup":
      return (
        <>
          <Route path="/InsuranceSetup" element={<InsuranceSetup />} />
        </>
      );

       case "/ItemMSP":
      return (
        <>
          <Route
            path="/ItemMSP"
            element={<ItemMSP/>}
          />
         
        </>
      );

    // Add more cases for other WebRoutes if needed
    default:
      return <Route path="*" element={<GCPageNotFound />} />;
  }
}

const ProjectRoutes = () => {
  const routes = useSelector((state) => state.SliceDB.value.routes);

  return (
    <div>
      {process.env.NODE_ENV !== "production" ? (
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            {/* <Route path="/WmsInbound" element={<Grn />} /> */}
            <Route path="/InstantPicking" element={<InstantPickingHead />} />
            <Route path="/VirtualBinDetail" element={<VirtualBinDetail />} />
            <Route
              path="/WmsPhysicalStockVariance"
              element={<WmsPhysicalStockVariance />}
            />
            <Route path="/deliverySummary" element={<DeliverySummary />} />
            <Route path="/deliveryDetail" element={<DeliveryDetail />} />
            <Route
              path="/deliveryItemDetail"
              element={<DeliveryItemDetail />}
            />
            <Route
              path="/InstantPickingDetail"
              element={<InstantPickingDetail />}
            />
            <Route path="/Picking" element={<Picking />} />
            <Route path="/PickingDetailView" element={<PickingDetailView />} />
            <Route path="/BinTransferData" element={<BinTransferData />} />
            <Route path="/BinTrnasferForm" element={<BinTrnasferForm />} />
            <Route path="/BinTransfer/:id" element={<BinTransferDetail />} />

            {/* <Route path="/WmsSalesInvoice" element={<WmsSalesInvoice />} /> */}
            <Route path="/WmsSalesInvoice" element={<WmsSalesInvoiceV1 />} />
            <Route path="/SalesInvoice" element={<SalesInvoice />} />
            <Route path="/SalesReturn" element={<SalesReturn />} />
            <Route path="/DeliveryNote" element={<DelieveryNote />} />
            <Route path="/SalesInvoice001" element={<SalesInvoicev1 />} />
            {/* <Route path="/WmsInboundGRN" element={<WmsInboundGRN />} /> */}
            <Route path="/WmsInboundGRN" element={<WmsInboundGRNV1 />} />
            <Route path="/grn" element={<GRNNormal />} />
            {/* <Route path="/WmsOutboundGRV" element={<WmsOutboundGRV />} /> */}
            <Route path="/WmsOutboundGRV" element={<WmsOutboundGRVV1 />} />
            <Route path="/grv" element={<GRV />} />
            <Route path="/WmsStockTransfer" element={<WmsStockTransfer />} />
            <Route path="/stocktransfer" element={<StockTransferNormal />} />
            <Route
              path="/StockTransferRequest"
              element={<StockTransferRequest />}
            />
            <Route
              path="/StockAdjustment"
              element={<StockAdjustmentNormal />}
            />
            <Route path="/WmsLoadingReceipt" element={<WmsLoadingReceipt />} />
            <Route path="/binMaster" element={<Bin />} />
            <Route path="/driver" element={<Driver />} />
            <Route path="/wmsDashoard" element={<WmsDashboard />} />
            <Route
              path="/WmsDashboardDetail"
              element={<WmsDashboardDetail />}
            />
            <Route path="/truck" element={<Truck />} />
            <Route path="/LoadingList" element={<LoadingList />} />

            <Route path="/WMSDispatch" element={<DispatchHead />} />
            <Route path="/DispatchDetail" element={<DispatchDetail />} />

            <Route path="/Loading" element={<LoadingHead />} />
            <Route path="/LoadingDetail" element={<LoadingDetail />} />
            <Route path="/EasyLoading" element={<EasyLoadingHead />} />
            <Route path="/EasyLoadingDetail" element={<EasyLoadingDetail />} />

            <Route path="/Notification" element={<NotificationSummary />} />
            <Route path="/PickingHead" element={<PickingHead />} />
            <Route
              path="/PickingPendingList"
              element={<PickingPendingList />}
            />
            <Route path="/PickingDetail" element={<PickingDetail />} />

            <Route path="/StockEnquiry" element={<StockEnquiry />} />
            <Route path="/priceenquiry" element={<PriceEnquiry />} />
            <Route path="/WHPicking" element={<WHPickingSummary />} />
            <Route path="/WHPickingDetail" element={<WHPickingDetail />} />
            <Route path="/DCItemsPriority" element={<DCItemsPriority />} />
            <Route path="/SalesGroupUpdate" element={<SalesGroupUpdate />} />
            <Route path="/DoStamping" element={<DoStamping />} />

            <Route
              path="/WmsStockAdjustment"
              element={<WmsStockAdjustment />}
            />

            <Route
              path="/WmsPhysicalStock"
              element={<WmsPhysicalStockCount />}
            />
            <Route
              path="/WmsPhysicalStockDetail"
              element={<WmsPhysicalStockCountDetail />}
            />
            <Route
              path="/WmsPhysicalStockCount"
              element={<WmsPhysicalStockCounting />}
            />

            <Route
              path="/WmsPoPhysicalStock"
              element={<WmsPoPhysicalStockCount />}
            />
            <Route
              path="/WmsPoPhysicalStockDetail"
              element={<WmsPoPhysicalStockCountDetail />}
            />
            <Route path="/cyclecount" element={<Cyclecount />} />
            <Route path="/cyclecountDetail" element={<CyclecountDetail />} />

            <Route path="/PhysicalStock" element={<PhysicalStock />} />
            <Route
              path="/PhysicalStockDetail"
              element={<PhysicalStockDetail />}
            />
            <Route
              path="/StockTransferReceipt"
              element={<StockTransferReceipt />}
            />
            <Route
              path="/StockTransferReceiptDetail"
              element={<StockTransferReceiptDetail />}
            />

            <Route path="/PutAway" element={<PutAway />} />
            <Route path="/PutAwayDetail" element={<PutAwayDetail />} />
            <Route path="/EasyPutAway" element={<EasyPutAway />} />
            <Route path="/EasyPutAwayDetail" element={<EasyPutAwayDetail />} />
            <Route path="/WMSStockReport" element={<WMSStockReport />} />
            <Route path="/WMSSalesReport" element={<WMSSalesReport />} />
            <Route
              path="/PendingDoDetailReport"
              element={<PendingDoDetailReport />}
            />
            <Route path="/TransDetailReport" element={<TransDetailReport />} />
            <Route path="/BinTransferReport" element={<BinTransferReport />} />
            <Route
              path="/DcCostCompareHistoryReport"
              element={<DcCostCompareHistoryReport />}
            />
            <Route
              path="/DcItemsStatusReport"
              element={<DcItemsStatusReport />}
            />
            <Route
              path="/PoCostCompareReport"
              element={<PoCostCompareReport />}
            />
            <Route
              path="/BranchToDcTsrDetailReport"
              element={<BranchToDcTsrDetailReport />}
            />
            <Route path="/DcRebateDetail" element={<DcRebateDetailReport />} />
            <Route
              path="/OutletPlanningReport"
              element={<OutletPlanningReport />}
            />
            <Route path="/DCRequest" element={<DCRequest />} />
            <Route path="/SalesQuotation" element={<SalesQuotation />} />
            <Route path="/SalesOrder" element={<SalesOrder />} />
            <Route path="/FactTransSync" element={<FactTransaction />} />
            <Route
              path="/EasyBinTransferSummary"
              element={<EasyBinTransferSummary />}
            />
            <Route path="/EasyItemTransfer" element={<EasyItemTransfer />} />
            <Route
              path="/EasyItemTransferDetail"
              element={<EasyItemTransferDetail />}
            />
            <Route
              path="/EasyCardIdTransfer"
              element={<EasyCardIdTransfer />}
            />
            <Route
              path="/EasyCardIdTransferDetail"
              element={<EasyCardIdTransferDetail />}
            />
            <Route path="/EasyBinTransfer" element={<EasyBinTransfer />} />
            <Route
              path="/EasyBinTransferDetail"
              element={<EasyBinTransferDetail />}
            />
            <Route
              path="/InboundProcessFlowReport"
              element={<InboundProcessFlowReport />}
            />
            <Route
              path="/PutawayDiscrepancyReport"
              element={<PutawayDiscrepancyReport />}
            />
            <Route path="/EmptyBinQurey" element={<EmptyBinQurey />} />
            <Route path="/DispatchDetails" element={<DispatchDetails />} />
            <Route path="/TripDetail" element={<TripDetailSummary />} />
            <Route
              path="/segregationSummary"
              element={<SegregationSummary />}
            />
            <Route
              path="/segregationItemScan"
              element={<SegregationItemScan />}
            />
            <Route
              path="/segregrationDetail"
              element={<SegregrationDetail />}
            />
            <Route path="/dropIdEnquiry" element={<DropIdEnquiry />} />
            <Route path="/BarcodeScanning" element={<BarcodeScanning />} />
            <Route path="/Test" element={<Test />} />
            <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
            <Route path="/mposordertaking" element={<OrderTakingFromCar />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/mposorderpicking" element={<OrderPicking />} />
            <Route
              path="/mposrderpickingDetail/:orderId"
              element={<OrderDetailPage />}
            />
            <Route path="/mposorderdelivery" element={<OrderDelivery />} />
            <Route
              path="/orderDeliveryDetail/:deliveryId"
              element={<OrderDeliveryDetail />}
            />
            <Route path="/mposorderenquiry" element={<Enquiry />} />
            <Route path="/mposorderpending" element={<OrderCancel />} />
            <Route path="preview-pdf" element={<PdfPreview />} />
            <Route path="VendorCreditNote" element={<VendorCreditNote />} />
            <Route path="/BatchOut" element={<BatchOut />} />
            <Route path="/BatchOutDetail" element={<BatchOutDetail />} />
            <Route
              path="/ItemRequestSummary"
              element={<ItemRequestSummary />}
            />
            <Route
              path="/ItemCreationRequest"
              element={<ItemCreationRequest />}
            />
            <Route
              path="/ItemApproveSummary"
              element={<ItemApproveSummary />}
            />
            <Route path="/ItemApproveDetail" element={<ItemApproveDetail />} />
            <Route path="/WmsInboundGRNV1" element={<WmsInboundGRNV1 />} />
            <Route
              path="/CycleCountAdjustment"
              element={<CycleCountAdjustment />}
            />
            <Route
              path="/CycleCountCounting"
              element={<CycleCountCounting />}
            />
            <Route path="/CycleCountSetting" element={<CycleCountSetting />} />
            <Route
              path="/CycleCountVariance"
              element={<CycleCountVariance />}
            />
            <Route path="/HRMonthlyReview" element={<HRMonthlyReview />} />
            <Route
              path="/HRMonthlyReviewApprove"
              element={<HRMonthlyReviewApprove />}
            />
            <Route path="/HRReviewReport" element={<HRReviewReport />} />
            <Route path="/WmsInboundVendor" element={<WmsInboundVendor />} />
            <Route path="/WmsInboundReturn" element={<WmsInboundReturn />} />
            <Route path="/WmsInboundOutlet" element={<WmsInboundOutlet />} />
            <Route
              path="/WmsPoPhysicalSetting"
              element={<WmsPoPhysicalStockCountSetup />}
            />
            <Route path="/HRSalaryAppraisal" element={<HRSalaryAppraisal />} />
            <Route path="/MobileCoupen" element={<MobileCoupen />} />
            <Route path="/BinWiseCBMRreport" element={<BinWiseCBMRreport />} />
            <Route
              path="/PickersPerformance"
              element={<PickersPerformance />}
            />

            <Route path="/boxpalletreceipt" element={<BoxPalletReceipt />} />
            <Route path="/boxpalletissue" element={<BoxPalletReceipt />} />
            <Route path="/boxpalletreport" element={<BoxPalletReport />} />
            <Route path="/LoadingPalletId" element={<LoadingPalletId />} />
            <Route path="/AppPromotion" element={<PromoSummary />} />
            <Route path="/StockSetupApprove" element={<StockSetupApprove />} />
            <Route
              path="/WmsPoPhysicalStockVariance"
              element={<WmsPoGenerateVaraiance />}
            />
            <Route path="/WmsTrackerReport" element={<WmsTrackerReport />} />

            <Route path="/ItemRSPRequest" element={<RSPChangeSummary />} />

            <Route
              path="/RSPChangeRequestDetail"
              element={<RSPChangeDetail />}
            />

            <Route
              path="/StockSetupChangeRequest"
              element={<StockSetupChangeRequest />}
            />
            <Route
              path="/StockSetupChangeRequestDetail"
              element={<StockSetupChangeRequestDetail />}
            />
            <Route
              path="/StockSetupChangeApprove"
              element={<StockSetupChangeApprove />}
            />
            <Route
              path="/StockSetupChangeApprovePM"
              element={<StockSetupChangeApprove />}
            />
            <Route
              path="/StockSetupChangeApproveCM"
              element={<StockSetupChangeApprove />}
            />
            <Route
              path="/VendorDiscontinueChangeApprove"
              element={<VendorDiscontinueChangeApprove />}
            />
            <Route
              path="/VendorDiscontinueChangeApproveCM"
              element={<VendorDiscontinueChangeApprove />}
            />
            <Route
              path="/VendorDiscontinueChangeApprovePM"
              element={<VendorDiscontinueChangeApprove />}
            />
            <Route
              path="/VendorDiscontinueChangeRequest"
              element={<VendorDiscontinueChangeRequest />}
            />
            <Route
              path="/VendorDiscontinueChangeRequestDetail"
              element={<VendorDiscontinueChangeRequestDetail />}
            />
            <Route path="/ItemListingApprove" element={<ItemListApprove />} />
            <Route path="/ItemListingApproveCM" element={<ItemListApprove />} />
            <Route path="/ItemListingApprovePM" element={<ItemListApprove />} />
            <Route path="/ItemMoqApprove" element={<MOQApprove />} />
            <Route path="/ItemMoqApproveCM" element={<MOQApprove />} />
            <Route path="/ItemMoqApprovePM" element={<MOQApprove />} />
            <Route
              path="/ItemListingRequest"
              element={<ItemListingRequest />}
            />
            <Route
              path="/ItemListingDetail"
              element={<ItemListingRequestDetail />}
            />
            <Route path="/ItemMoqRequest" element={<ItemMoqRequest />} />
            <Route path="/ItemMoqDetail" element={<ItemMoqRequestDetail />} />
            <Route path="*" element={<GCPageNotFound />} />
            <Route path="/DiscountCoupon" element={<CouponSummary />} />

            {/* Restaurant order booking routes */}
            <Route path="/TableOrder" element={<RestaurantOrderSummary />} />

            <Route path="/BrandSearch" element={<BrandSearchPicker />} />
            <Route
              path="/wmsPutawayGeneration"
              element={<PutAwayGeneration />}
            />
            <Route path="/wmsPutaway" element={<WmsPutAway />} />

            <Route path="/WmsPutAwayDetail" element={<WmsPutAwayDetail />} />

            <Route path="/FinanceGeneralLedger" element={<GeneralLedger />} />
            <Route
              path="/FinanceReceivableReport"
              element={<FinanceReceivableReport />}
            />
            <Route
              path="/FinanceTrialBalanceReport"
              element={<FinanceTrialBalanceReport />}
            />
            <Route
              path="/FinancePayableReport"
              element={<FinancePayableReport />}
            />
            <Route path="/GenrateAPIKey" element={<GenerateApiKey />} />
            <Route
              path="/ZatcaTransactionSummary"
              element={<ZatcaTransactionSummary />}
            />
            <Route
              path="/ZatcaTransactionDetail"
              element={<ZatcaTransactionDetail />}
            />
            <Route
              path="/ItemRSPApprove"
              element={<RSPChangeApproveSummary />}
            />
            <Route
              path="/ItemRSPApproveCM"
              element={<RSPChangeApproveSummary />}
            />
            <Route
              path="/ItemRSPApprovePM"
              element={<RSPChangeApproveSummary />}
            />
            <Route path="//ItemRejectReport" element={<RSPRejectReport />} />

            <Route
              path="/ImportPurchasePlanning"
              element={<ImportPurchaseSummary />}
            />
            <Route path="/ImportPurchaseSummary" element={<ImportPurchase />} />
            <Route
              path="/ImportPurchaseClose"
              element={<PurchaseCloseSummary />}
            />
            <Route
              path="/ImportPurchaseTrip"
              element={<TripPlanningSummary />}
            />

            <Route
              path="/ImportItemCreation"
              element={<ItemCreationSummary />}
            />

            <Route path="/DirectPriceChange" element={<DirectPriceChange />} />
            <Route
              path="/VansalesCustomer"
              element={<VansalesCustomerSummary />}
            />
            <Route
              path="/FreshPurchasePosting"
              element={<FreshPurchasePosting />}
            />
            <Route path="/FreshDcMargin" element={<FreshDcMargin />} />
            <Route
              path="/PromotionCreation"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionCategory"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionItems"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionItemsVerify"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionDesign"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionProofReading"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionPrint"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionReceived"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionDistribution"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionAnalysis"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/PromotionCreditNote"
              element={<PromotionAutomationSummary />}
            />
            <Route
              path="/StockSetupTemplate"
              element={<StockSetupTemplate />}
            />
            <Route
              path="/BranchClassification"
              element={<BranchClassification />}
            />
            <Route path="/InsuranceSetup" element={<InsuranceSetup />} />
            <Route path="/ItemsMSP" element={<ItemMSP />} />
            <Route path="/ItemsMSPExcel" element={<ItemMSPExcel />} />
             <Route path="/PickingList" element={<PickingList />} />
            <Route
              path="/StockSetupDaysTemplate"
              element={<StockSetupDaysTemplate />}
            />
          </Route>
          <Route path="*" element={<GCPageNotFound />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {routes?.length > 0 &&
              routes?.map((route, index) => {
                const routeComponent = getRouteComponent(route?.WebRoute);
                return React.Children.map(
                  routeComponent,
                  (child, childIndex) => {
                    return React.cloneElement(child, {
                      key: `route_${index}_${childIndex}`,
                    });
                  }
                );
              })}
          </Route>
          <Route path="*" element={<GCPageNotFound />} />
        </Routes>
      )}
    </div>
  );
};

export default ProjectRoutes;
